import { defineMessages } from 'react-intl';

export default defineMessages({
  linkGoogleCalendar: {
    id: 'google.calendar.linkGoogleCalendar',
    defaultMessage: 'Link Google Calendar',
  },
  hideAllCalendars: {
    id: 'google.calendar.hideAllCalendars',
    defaultMessage: 'Hide all calendars',
  },
  disconnectGoogleAccount: {
    id: 'google.calendar.disconnectGoogleAccount',
    defaultMessage: 'Disconnect Google Account',
  },
  personal: {
    id: 'google.calendar.personal',
    defaultMessage: 'Personal',
  },
  googleCalendarLinked: {
    id: 'google.calendar.googleCalendarLinked',
    defaultMessage: 'Google Calendar linked!',
  },
  linkError: {
    id: 'google.calendar.linkError',
    defaultMessage: 'Couldn\'t fetch your calendars. You\'re not logged into Google.',
  },
  logBack: {
    id: 'google.calendar.logBack',
    defaultMessage: 'Click here to log back in',
  },
});
